import Seo from "@/components/Seo";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import DocRenderer from "@/components/admin/DocBlocks";
import { SERVICE_GUIDE, SERVICE_GUIDE_META } from "@/content/pricingStrategy";
import { SITE } from "@/content/copy";
import { trackEvent } from "@/lib/analytics";

export default function PricingGuidePage() {
  return (
    <>
      <Seo
        title="Services & Pricing Guide | Clarus Partners"
        description="Monthly Xero bookkeeping plans from $1,000-$4,000/month plus GST, fixed-price clean-ups and business setup. Accountant-ready books, no hourly meters."
      />
      <Header />
      <main className="py-16 lg:py-24">
        <div data-testid="pricing-guide-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <DocRenderer
            meta={{ ...SERVICE_GUIDE_META, updated: "claruspartners.com.au · nima@claruspartners.com.au" }}
            sections={SERVICE_GUIDE}
            testId="pricing-guide-doc"
          />
          <div className="mt-12 rounded-2xl bg-navy text-white p-8 text-center">
            <h2 className="text-2xl font-bold tracking-tight">Not sure which plan fits?</h2>
            <p className="mt-3 text-white/70">
              Book a free 30-minute consultation - we'll tell you honestly which plan you need, including if that's none of them.
            </p>
            <a
              href={SITE.calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="pricing-guide-book-button"
              onClick={() => trackEvent("book_consultation_click", { location: "pricing_guide" })}
              className="mt-6 inline-flex justify-center items-center rounded-full bg-terracotta px-8 py-4 text-base font-bold text-white transition-all duration-300 hover:bg-terracotta-hover hover:-translate-y-0.5 hover:shadow-lg"
            >
              {SITE.consultLabel}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
